class StackedMobileSlider extends HTMLElement {
  constructor() {
    super();
    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.resizeObserver = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    this.destroy();
  }

  handleResize() {
    window.requestAnimationFrame(() => {
      if (this.isVisible()) {
        this.init();
        this.update();
      }
    });
  }

  isVisible() {
    return this.offsetParent !== null && this.offsetWidth > 0;
  }

  init() {
    if (this.mainSwiper) return;

    if (typeof Swiper === 'undefined') {
      window.setTimeout(this.handleResize, 50);
      return;
    }

    const mainEl = this.querySelector('[data-main-swiper]');
    const thumbsEl = this.querySelector('[data-thumbs-swiper]');

    if (!mainEl) return;

    if (thumbsEl) {
      this.thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 3.86,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        freeMode: true,
        centeredSlides: false,
        observer: true,
        observeParents: true,
      });
    }

    const swiperOptions = {
      autoHeight: true,
      watchOverflow: true,
      spaceBetween: 4,
      preventInteractionOnTransition: true,
      watchSlidesProgress: true,
      resizeObserver: true,
      observer: true,
      observeParents: true,
    };

    if (this.thumbsSwiper) {
      swiperOptions.thumbs = { swiper: this.thumbsSwiper };
    }

    this.mainSwiper = new Swiper(mainEl, swiperOptions);
  }

  update() {
    if (this.thumbsSwiper) {
      this.thumbsSwiper.updateSize();
      this.thumbsSwiper.updateSlides();
      this.thumbsSwiper.update();
    }

    if (this.mainSwiper) {
      this.mainSwiper.updateSize();
      this.mainSwiper.updateSlides();
      this.mainSwiper.update();
    }
  }

  destroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }

    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }
  }
}

if (!customElements.get('stacked-mobile-slider')) {
  customElements.define('stacked-mobile-slider', StackedMobileSlider);
}
